/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
// import axios from "axios";
import parse from "html-react-parser";

class MyZzimItem extends Component {
  state = {
    mouseOn: false,
  };
  componentDidMount = () => {};
  _goItem = () => {
    const { setContentSerial } = this.props;
    const { contentSerial } = this.props.childProps;
    setContentSerial(contentSerial);
    //history.push('/items/' + contentSerial)
  };
  _change = () => {
    const { _selected, index, contentSerial } = this.props.childProps;
    //console.log(index, contentSerial)
    _selected(index, contentSerial);
  };
  render() {
    const {
      contentSerial,
      title,
      img,
      genreName,
      sameCode,
      restrictionCode,
      selected,
      contentSysnopsis,
    } = this.props.childProps;
    // const regex = /<p>/gi;
    //const result = contentSysnopsis.replace(/(<br>|<br\/>)/gi, '');
    let result = contentSysnopsis.replace(/(br)/gi, "");
    result = result.replace(/(< \/>)/gi, "");
    return (
      <Fragment>
        <ul>
          <li className="thumb" onClick={this._goItem}>
            <img src={img} style={{ cursor: "pointer" }} />
          </li>
          <li className="info">
            <p
              className="subject"
              onClick={this._goItem}
              style={{ cursor: "pointer" }}
            >
              {title}
            </p>
            <p className="detail">
              <span>{genreName}</span>
              <span>
                {sameCode.substr(0, 4)}.{sameCode.substr(4, 2)} 방영
              </span>
              <span>{restrictionCode}세 관람</span>
            </p>
            <div className="story">{parse(result)}</div>
          </li>
          {
            /*pos === 'view' ? null : (*/
            <Fragment>
              <input
                type="checkbox"
                className="chkBox"
                name="chk"
                checked={selected > 0 ? true : false}
                onChange={this._change}
                id={"chk" + contentSerial}
              />
              <label htmlFor={"chk" + contentSerial} className="chk"></label>
            </Fragment>
            /*)*/
          }
        </ul>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(React.memo(MyZzimItem)));
